/** Please don't modify or unzip this content. It will be updated regularly **/
    (function() {
      BoostPFS.inject(this);

      //Set global variable
      Globals.hasIntegration = true;

      function faLooxGetMetafield(data, key) {
        if (typeof Utils !== 'undefined' && typeof Utils.getProductMetafield === 'function') {
          var value = Utils.getProductMetafield(data, 'loox', key);
          if (value !== null && typeof value !== 'undefined') return value;
        }
        if (data && Array.isArray(data.metafields)) {
          for (var index = 0; index < data.metafields.length; index += 1) {
            if (data.metafields[index].namespace === 'loox' && data.metafields[index].key === key) {
              return data.metafields[index].value;
            }
          }
        }
        if (data && data.metafields && data.metafields.loox && typeof data.metafields.loox[key] !== 'undefined') {
          return data.metafields.loox[key];
        }
        return '';
      }

      function faLooxEscapeAttribute(value) {
        return String(value == null ? '' : value)
          .replace(/&/g, '&amp;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;');
      }

      function faLooxHasReviews(rating, count) {
        return rating !== '' && count !== '' && isFinite(rating) && isFinite(count) &&
          Number(rating) > 0 && Number(rating) <= 5 && Number(count) > 0 &&
          Math.floor(Number(count)) === Number(count);
      }

      function faLooxGetHandle(data) {
        if (data && data.handle) return String(data.handle);
        var url = data && data.url ? String(data.url) : '';
        var match = url.match(/\/products\/([^?#/]+)/);
        return match ? match[1] : '';
      }

      function faLooxBuildLinkedReviews(data) {
        if (!data || !data.id) return '';
        var rating = faLooxGetMetafield(data, 'avg_rating');
        var count = faLooxGetMetafield(data, 'num_reviews');
        var handle = faLooxGetHandle(data);
        var productUrl = data.url || (handle ? '/products/' + handle : '#');
        if (!faLooxHasReviews(rating, count)) {
          if (!handle) return '';
          return "<a class='loox-rating-link' href='" + faLooxEscapeAttribute(productUrl) + "#looxReviews'><span class='fa-loox-rating-shell' data-fa-loox-id='" + faLooxEscapeAttribute(data.id) + "' data-fa-loox-handle='" + faLooxEscapeAttribute(handle) + "' data-fa-loox-compact='true'></span></a>";
        }
        return "<a class='loox-rating-link' href='" + faLooxEscapeAttribute(productUrl) + "#looxReviews'><div class='loox-rating' data-id='" + faLooxEscapeAttribute(data.id) + "' data-rating='" + faLooxEscapeAttribute(rating) + "' data-raters='" + faLooxEscapeAttribute(count) + "' data-pattern='([count])'></div></a>";
      }

      // 3rd app compile template
      Integration.compileIntegrationTemplate = function (data, itemHtml) {
        var itemReviewsHtml = faLooxBuildLinkedReviews(data);
        itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewsHtml);
        return itemHtml;
      };

      Integration.call3rdIntegrationFunc = function(data) {
        
      }

    })();
